"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameMode52 = void 0;
const CTGGameMode4x4_1 = require("./CTGGameMode4x4");
class CTGGameMode52 extends CTGGameMode4x4_1.CTGGameMode4x4 {
    constructor(generator, validator, difficulty_mod, min_cards, rotate_cards, animators) {
        super(generator, validator, difficulty_mod, min_cards, true, animators);
        this.rotate_cards = rotate_cards;
        this.min_cards = min_cards;
    }
    generate_initial_cards(rand, difficulty) {
        let num = difficulty * this.difficulty_mod * (52 - this.min_cards) + this.min_cards;
        let cards = this.generator.getCards(rand, difficulty * this.difficulty_mod, this.min_cards, 52);
        let specs = [];
        for (let i = 0; i < cards.length; i++) {
            this.set_random_point(rand, cards[i], this.rotate_cards);
            specs.push(cards[i]);
        }
        return specs;
    }
    set_random_point(rand, card, rotate) {
        card.x = rand.nextInt(8, 64 - 12);
        card.y = rand.nextInt(8, 64 - 7);
        card.rot = 90 * (rotate ? rand.nextInt(-1, 2) : 0);
    }
}
exports.CTGGameMode52 = CTGGameMode52;
